/**
 * A component that displays information about a capped product
 */
export const CappedProductInfoBanner: ng.IComponentOptions = {
  bindings: {
    usageEventProductMappingId: '=',
    events: '='
  },
  templateUrl: 'app/angularJS/components/capped-product-info-banner/capped-product-info-banner.html',
  controller: 'CappedProductInfoBannerController',
  controllerAs: 'vm'
};